export enum MutationTypes {
  TOGGLE_MARKERS_LOADING = 'TOGGLE_MARKERS_LOADING',
  TOGGLE_DRAWER = 'TOGGLE_DRAWER',
  SET_IMEI = 'SET_IMEI',
  SET_MARKER = 'SET_MARKER',
  SET_SEARCH_FILTERED = 'SET_SEARCH_FILTERED',
  SET_SEARCH_BOUNDING = 'SET_SEARCH_BOUNDING',
}
